import mod from "-!./U3Search.js?vue&type=script&lang=js&"; export default mod; export * from "-!./U3Search.js?vue&type=script&lang=js&"